'use client';

import { c as _c } from "react/compiler-runtime";
import cn from 'clsx';
import { useLenis } from 'lenis/react';
import { useRef, useState } from 'react';
import { Link } from '~/components/link';
import { ThemeButton } from '~/components/theme-button';
import { useCartContext } from '~/integrations/shopify/cart/cart-context';
import { useCartModal } from '~/integrations/shopify/cart/modal';
import { useStore } from '~/libs/store';
import s from './footer.module.css';
export function Footer() {
  const $ = _c(14);
  const {
    totalQuantity
  } = useCartContext();
  const {
    openCart
  } = useCartModal();
  const itemCount = totalQuantity();
  const lastScrollY = useRef(0);
  const footerRef = useRef(null);
  useLenis();
  const isFooterFullyInView = useStore(_temp);
  const [isScrollingDown, setIsScrollingDown] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = lenis => {
      if (!lenis) {
        return;
      }
      const currentScrollY = lenis.scroll;
      setIsScrollingDown(currentScrollY > lastScrollY.current);
      lastScrollY.current = currentScrollY;
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useLenis(t0);
  const t1 = isScrollingDown && !isFooterFullyInView && s.hidden;
  let t2;
  if ($[1] !== t1) {
    t2 = cn(s.footer, "desktop-only sticky col-span-full bottom-0 p uppercase  h-header-height z-20", t1);
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={cn(s.buttons, "grid grid-cols-2 items-center justify-center absolute left-0")}><ThemeButton square={true} className="spy-6 spx-8 bg-contrast" theme="light" /><ThemeButton square={true} className="spy-6 spx-8 bg-contrast" theme="simple" /></div>;
    t4 = <Link className="cta cta-hover bg-contrast spx-8 spy-4 w-fit relative flex items-center col-start-5 col-span-2" href="https://github.com/sponsors/darkroomengineering">Become an Open Source Sponsor</Link>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== itemCount || $[6] !== openCart) {
    t5 = itemCount > 0 && <button type="button" onClick={openCart} className="cta cta-hover bg-contrast spx-8 spy-4 w-fit relative flex items-center col-start-8">CART <sup className={cn(s.itemCount, "align-top dis")}>[{itemCount}]</sup></button>;
    $[5] = itemCount;
    $[6] = openCart;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={cn(s.buttons, "grid grid-cols-2 items-center justify-center absolute right-0")}><ThemeButton square={true} className="spy-6 spx-8 bg-contrast" theme="dark" /><ThemeButton square={true} className="spy-6 spx-8 bg-contrast" theme="red" /></div>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5) {
    t7 = <div className="dr-grid relative">{t3}{t4}{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t2 || $[12] !== t7) {
    t8 = <footer ref={footerRef} className={t2}>{t7}</footer>;
    $[11] = t2;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}
function _temp(state) {
  return state.isFooterFullyInView;
}